
<template>
  <div>
    <!-- <p class="header text-title-second">Interactive artist interested in digital<br>tool-making</p> -->
    <!-- <h3 class="recent text-subtitle-second">Recent Work</h3> -->
    <div :class="['rows', {'show-projects': shouldShowProjects}]">
      <ProjectRow
        v-for   ="(project, rIndex) in projectsMeta"
        v-bind  ="project"
        :key    ="project.title + rIndex"
        :style="{transition: `opacity 333ms ease-in ${rIndex * 111}ms, transform 333ms ease-in ${rIndex * 111}ms`}"
        @content-loaded="onLoad"
      />
    </div>
    <!-- <a href='https://github.com/ldrummond/portfolio_2020' class="copyright text-caps">2019 (C) Lucas Drummond</a> -->
  </div>
</template>
<script>
import ProjectRow from '../components/ProjectRow.vue';

export default {
  name: 'Overview',
  props: ['siteMeta', 'projectsMeta'],
  data() {
    return {
      loadedProjects: 0,
      delayed: false, 
    }
  },
  components: {
    ProjectRow,
	},
	computed: {
    shouldShowProjects() { 
      return this.delayed || (this.loadedProjects >= this.projectsMeta.length) || this.delayed;
    }
  },
  methods: {
    onLoad() {
      this.loadedProjects += 1;   
    }
  },
  mounted() {    
    setTimeout(() => {
      this.delayed = true; 
    }, 100);
  }
}
</script>

<style lang="sass" scoped>
@import '../assets/partials/_vars'

.name
  font-size: 1.4rem
  letter-spacing: 0.01em
  font-weight: 400
  text-transform: uppercase
  margin-bottom: 1rem

.header
  margin-top: 10rem
  color: $primary-color
  margin-bottom: 15rem

.recent
  display: block
  margin-bottom: 3rem

.rows
  display: flex
  flex-wrap: wrap
  flex-direction: column
  position: relative
  padding-bottom: 5rem
  .project
    opacity: 0
    transform: translateY(5px)
  &.show-projects
    .project
      opacity: 1
      transform: translateY(0px)

.copyright
  display: block
  width: 100%
  color: #555 // $tertiary-color
  font-weight: 100
  text-align: right
  padding: 2rem 0

+after-bg-mobile
  .rows
    display: grid
    grid-template-columns: repeat(2, minmax(0, 1fr)) 
    column-gap: 1/28 * 100vw
    width: 100%
    padding: 0
    z-index: 20

  .header
    margin-top: 0

+after-sm-desktop
  .header
    width: 6/8 * 100vw

  .copyright
    padding: 2rem 1/28 * 100vw
    display: none

</style>
